<template>
  <div>
    <common-dialog ref="dialog" width="500px" show-save-button unit="业务类型" edit-title id-key="BusinessTypeId"
      :getDataFunc="api.info" :data="data" :line-form="true" form-label-width="110px" :form-rules="rules"
      :save-func="api.save" @opened="onOpened" @create-opened="onCreateOpened" @edit-opened="onEditOpened"
      @closed="onClosed" @close-saved="$emit('close-saved')">
      <template slot="form">
        <el-form-item label="业务类型编号" prop="BusinessTypeNo">
          <!-- <el-input v-model="data.BusinessTypeNo" placeholder="请输入业务类型编号" /> -->
          <span v-if="Mode==0" class="detail-span">{{data.BusinessTypeNo}}</span>
              <el-input v-else v-model="data.BusinessTypeNo" placeholder="请输入业务类型编号"></el-input>
        </el-form-item>
        <el-form-item label="业务类型名称" prop="BusinessType">
          <el-input v-model="data.BusinessType" placeholder="请输入业务类型名称" />
        </el-form-item>
        <el-form-item label="入库类别">
          <el-select v-model="data.InClassId">
            <el-option v-for="i in GetList" :key="i.ClassId" :value="i.ClassId" :label="i.ClassName" />
          </el-select>
        </el-form-item>
        <el-form-item label="出库类别">
          <el-select v-model="data.OutClassId">
            <el-option v-for="i in PutList" :key="i.ClassId" :value="i.ClassId" :label="i.ClassName" />
          </el-select>
        </el-form-item>
        <el-form-item label="类别">
          <el-select v-model="data.Kind">
            <el-option value="应收" label="应收"></el-option>
            <el-option value="应付" label="应付"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="data.NeedTradeUnit">是否需要往来单位</el-checkbox>
        </el-form-item>
        <el-form-item label="单据类型">
          <invoice-select v-model="data.SourceTypeId" :clearable="false" />
        </el-form-item>
        <el-form-item label="序号">
          <el-input type="number" v-model.number="data.SerialNumber" style="width: 100px"></el-input>
          <span class="t-tips">*值越小排得越前</span>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import invoiceSelect from "@/components/basedata/basedoc/billtype/select";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
  },
  data() {
    return {
      data: {
        BusinessTypeId: 0,
        BusinessTypeNo: null,
        BusinessType: "",
        Kind: null,
        SerialNumber: null,
        NeedTradeUnit: false,
        SourceTypeId: null,
        InClassId: null,
        OutClassId: null,
      },
      Mode: 1,
      code_api: require("@/api/sy/serialCode").default,
      formApi: require("@/api/sy/formSetting").default,
      api: require("@/api/ba/businessType").default,
      classApi: require("@/api/ba/class").default,

      // trendData: iForm.Data,
      showList: [],
      PutList: [],
      GetList: [],
      rules: {
        BusinessTypeNo: [{ required: true, message: "请输入编号" }],
        BusinessType: [{ required: true, message: "请输入名称" }],
        Sn: [{ required: true, message: "请输入序号" }],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash
        ? this.urlHash.split("/").join("")
        : location.hash.split("/").slice(1).join("");

      //类别
      this.classApi.list({ ClassType: 16 }).then((res) => {
        this.PutList = res.Data.filter((i) => i.PclassName == "发");
        this.GetList = res.Data.filter((i) => i.PclassName == "收");
      });
      this.formApi.list({ type: modeName }).then((res) => {
        this.showList = res.Data?.map((x) => x.ShowField);
      });
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true;
      return this.showList.indexOf(data) !== -1 ? true : false;
    },
    onCreateOpened(data) {
      this.serialCode()
      this.api.getMaxSn().then((res) => {
        this.data.SerialNumber = res;
      });
    },
    onEditOpened(data) { },
    onClosed() {
      this.showList = [];
    },
    serialCode() {
      this.code_api.previewNo("业务类型").then((res) => {
        console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.BusinessTypeNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取业务类型编号失败");
        }
      });
    },
  },
};
</script>
